import React from 'react';
import {Bar} from 'react-chartjs-2';
import Box from '@material-ui/core/Box';
import * as Math from "mathjs"


let data = {
  labels: ['Mild', 'Moderate', 'Severe', 'Critical'],

  datasets: [
    {
      label: 'Estimated Probability',
      backgroundColor: 'rgba(255,99,132,0.2)',
      borderColor: 'rgba(255,99,132,0.5)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      hoverBorderColor: 'rgba(255,99,132,1)',
      data: [0.65, 0.32, 0.03, 0.01]
    }
  ]
};


const Output = (props) => {
  const output1 = (data)=>{
    let {
      age,
      sob,
      temperature,
      hct,
      hgb,
      lymphocyte,
      wbc,
      plt
    } = data

    // Process Data: Standardize & Age transformation
    let age1 = 0
    let age2 = 0
    let age3 = 0

    if (age < 20) {
      age1 = -7
      age2 = 7
      age3 = -7
    } else if (age < 30) {
      age1 = -5
      age2 = 1
      age3 = 5
    } else if (age < 40) {
      age1 = -3
      age2 = -3
      age3 = 7
    } else if (age < 50) {
      age1 = -1
      age2 = -5
      age3 = 3
    } else if (age < 60) {
      age1 = 1
      age2 = -5
      age3 = -3
    } else if (age < 70) {
      age1 = 3
      age2 = -3
      age3 = -7
    } else if (age < 80) {
      age1 = 5
      age2 = 1
      age3 = -5
    } else {
      age1 = 7
      age2 = 7
      age3 = 7
    }

    temperature = (temperature > 37.5)
      ? 1
      : 0
    hct = (hct - 39.2609) / 4.9382
    hgb = (hgb - 13.2827) / 1.7563
    lymphocyte = (lymphocyte - 29.1430) / 11.6875
    wbc = (wbc - 6126) /2824
    plt = (plt - 237882.4) / 83295.69
    // Calculate Coef and etc from R

    // coef : age1, sob2, temp3, lympho6, plt8
    const coef0 = -2.031
    const [coef1, coef2, coef3, coef4, coef5, coef6, coef7, coef8] = [
      [
        0.243, 0.076, 0.035
      ],
      1.434,
      0.875,
      0,
      0,
      -0.616,
      0,
      -0.339
    ]
    const [ageMin, sobMin, tempMin, hctMin, hgbMin, lympMin, wbcMin, pltMin] = [
      Math.min(coef1[0] * (-7), coef1[0] * (7)) + Math.min(coef1[1] * (-5), coef1[1] * (7)) + Math.min(coef1[2] * (-7), coef1[2] * (7)),
      Math.min(coef2 * 0, coef2 * 1),
      Math.min(coef3 * 0, coef3 * 1),
      Math.min(coef4*(11.6-39.2609)/4.9382,coef4*(72.9-39.2609)/4.9382),
      Math.min(coef5*(5.2-13.2827)/1.7563,coef5*(20.3-13.2827)/1.7563),
      Math.min(coef6 * (1.2 - 29.1430) / 11.6875, coef6 * (84.1 - 29.1430) / 11.6875),
      Math.min(coef7*(660-6126)/2824,coef7*(55000-6126)/2824),
      Math.min(coef8 * (5300 - 237882.4) / 83295.69, coef8* (734000 - 237882.4) / 83295.69)
    ]
    // Max는 coef가 곱해진 값이다!!
    const [ageMax, sobMax, tempMax, hctMax, hgbMax, lympMax, wbcMax, pltMax] = [
      Math.max(coef1[0] * (-7), coef1[0] * (7)) + Math.max(coef1[1] * (-5), coef1[1] * (7)) + Math.max(coef1[2] * (-7), coef1[2] * (7)),
      Math.max(coef2 * 0, coef2 * 1),
      Math.max(coef3 * 0, coef3 * 1),
      Math.max(coef4*(11.6-39.2609)/4.9382,coef4*(72.9-39.2609)/4.9382),
      Math.max(coef5*(5.2-13.2827)/1.7563,coef5*(20.3-13.2827)/1.7563),
      Math.max(coef6 * (1.2 - 29.1430) / 11.6875, coef6 * (84.1 - 29.1430) / 11.6875),
      Math.max(coef7*(660-6126)/2824,coef7*(55000-6126)/2824),
      Math.max(coef8 * (5300 - 237882.4) / 83295.69, coef8* (734000 - 237882.4) / 83295.69)
    ]
    // Calculating
    const ageVal = (age1 * coef1[0]) + (age2 * coef1[1]) + (age3 * coef1[2])
    const sobVal = sob * coef2
    const tempVal = temperature * coef3
    const hctVal = hct * coef4
    const hgbVal = hgb * coef5
    const lympVal = lymphocyte * coef6
    const wbcVal = wbc * coef7
    const pltVal = plt * coef8
    const agePoint = (ageVal - ageMin)
    const sobPoint = (sobVal - sobMin)
    const tempPoint = (tempVal - tempMin)
    const hctPoint = (hctVal - hctMin)
    const hgbPoint = (hgbVal - hgbMin)
    const lympPoint = (lympVal - lympMin)
    const wbcPoint = (wbcVal - wbcMin)
    const pltPoint = (pltVal - pltMin)
    const totalPoint = agePoint + sobPoint + tempPoint + hctPoint + hgbPoint + lympPoint + wbcPoint + pltPoint
    const maxPoint = ageMax + sobMax + tempMax + hctMax + hgbMax + lympMax + wbcMax + pltMax - (ageMin + sobMin + tempMin + hctMin + hgbMin + lympMin + wbcMin + pltMin)
    const logit = coef0 + ageVal + sobVal + tempVal + hctVal + hgbVal + lympVal + wbcVal + pltVal
    const prob = Math.exp(logit) / (Math.exp(logit) + 1)
    return(prob)
  }

  const output2 = (data) => {
    let {
      age,
      sob,
      temperature,
      hct,
      hgb,
      lymphocyte,
      wbc,
      plt
    } = data

    // Process Data: Standardize & Age transformation
    let age1 = 0
    let age2 = 0
    let age3 = 0

    if (age < 20) {
      age1 = -7
      age2 = 7
      age3 = -7
    } else if (age < 30) {
      age1 = -5
      age2 = 1
      age3 = 5
    } else if (age < 40) {
      age1 = -3
      age2 = -3
      age3 = 7
    } else if (age < 50) {
      age1 = -1
      age2 = -5
      age3 = 3
    } else if (age < 60) {
      age1 = 1
      age2 = -5
      age3 = -3
    } else if (age < 70) {
      age1 = 3
      age2 = -3
      age3 = -7
    } else if (age < 80) {
      age1 = 5
      age2 = 1
      age3 = -5
    } else {
      age1 = 7
      age2 = 7
      age3 = 7
    }

    temperature = (temperature > 37.5)
      ? 1
      : 0
    hct = (hct - 39.2609) / 4.9382
    hgb = (hgb - 13.2827) / 1.7563
    lymphocyte = (lymphocyte - 29.1430) / 11.6875
    wbc = (wbc - 6126) / 2824
    plt = (plt - 237882.4) / 83295.69
    // Calculate Coef and etc from R
    // coef : age, sob, temp,hct, lympho, plt

    const coef0 = -2.77
    const [coef1, coef2, coef3, coef4, coef5, coef6, coef7, coef8] = [
      [
        0.249, 0.044, 0.002
      ],
      1.872,
      0.811,
      -0.106,
      0,
      -0.787,
      0,
      -0.378
    ]
    const [ageMin, sobMin, tempMin, hctMin, hgbMin, lympMin, wbcMin, pltMin] = [
      Math.min(coef1[0] * (-7), coef1[0] * (7)) + Math.min(coef1[1] * (-5), coef1[1] * (7)) + Math.min(coef1[2] * (-7), coef1[2] * (7)),
      Math.min(coef2 * 0, coef2 * 1),
      Math.min(coef3 * 0, coef3 * 1),
      Math.min(coef4 * (11.6 - 39.2609) / 4.9382, coef4 * (72.9 - 39.2609) / 4.9382),
      Math.min(coef5 * (5.2 - 13.2827) / 1.7563, coef5 * (20.3 - 13.2827) / 1.7563),
      Math.min(coef6 * (1.2 - 29.1430) / 11.6875, coef6 * (84.1 - 29.1430) / 11.6875),
      Math.min(coef7 * (660 - 6126) / 2824, coef7 * (55000 - 6126) / 2824),
      Math.min(coef8 * (5300 - 237882.4) / 83295.69, coef8 * (734000 - 237882.4) / 83295.69)
    ]
    // Max는 coef가 곱해진 값이다!!
    const [ageMax, sobMax, tempMax, hctMax, hgbMax, lympMax, wbcMax, pltMax] = [
      Math.max(coef1[0] * (-7), coef1[0] * (7)) + Math.max(coef1[1] * (-5), coef1[1] * (7)) + Math.max(coef1[2] * (-7), coef1[2] * (7)),
      Math.max(coef2 * 0, coef2 * 1),
      Math.max(coef3 * 0, coef3 * 1),
      Math.max(coef4 * (11.6 - 39.2609) / 4.9382, coef4 * (72.9 - 39.2609) / 4.9382),
      Math.max(coef5 * (5.2 - 13.2827) / 1.7563, coef5 * (20.3 - 13.2827) / 1.7563),
      Math.max(coef6 * (1.2 - 29.1430) / 11.6875, coef6 * (84.1 - 29.1430) / 11.6875),
      Math.max(coef7 * (660 - 6126) / 2824, coef7 * (55000 - 6126) / 2824),
      Math.max(coef8 * (5300 - 237882.4) / 83295.69, coef8 * (734000 - 237882.4) / 83295.69)
    ]
    // Calculating
    const ageVal = (age1 * coef1[0]) + (age2 * coef1[1]) + (age3 * coef1[2])
    const sobVal = sob * coef2
    const tempVal = temperature * coef3
    const hctVal = hct * coef4
    const hgbVal = hgb * coef5
    const lympVal = lymphocyte * coef6
    const wbcVal = wbc * coef7
    const pltVal = plt * coef8

    const agePoint = (ageVal - ageMin)
    const sobPoint = (sobVal - sobMin)
    const tempPoint = (tempVal - tempMin)
    const hctPoint = (hctVal - hctMin)
    const hgbPoint = (hgbVal - hgbMin)
    const lympPoint = (lympVal - lympMin)
    const wbcPoint = (wbcVal - wbcMin)
    const pltPoint = (pltVal - pltMin)

    const totalPoint = agePoint + sobPoint + tempPoint + hctPoint + hgbPoint + lympPoint + wbcPoint + pltPoint
    const maxPoint = ageMax + sobMax + tempMax + hctMax + hgbMax + lympMax + wbcMax + pltMax - (ageMin + sobMin + tempMin + hctMin + hgbMin + lympMin + wbcMin + pltMin)
    const logit = coef0 + ageVal + sobVal + tempVal + hctVal + hgbVal + lympVal + wbcVal + pltVal
    const prob = Math.exp(logit) / (Math.exp(logit) + 1)
    return(prob)
  }

  const output3 = (data) =>{
    let {
      age,
      sob,
      temperature,
      hct,
      hgb,
      lymphocyte,
      wbc,
      plt
    } = data

    // Process Data: Standardize & Age transformation
    let age1 = 0
    let age2 = 0
    let age3 = 0

    if (age < 20) {
      age1 = -7
      age2 = 7
      age3 = -7
    } else if (age < 30) {
      age1 = -5
      age2 = 1
      age3 = 5
    } else if (age < 40) {
      age1 = -3
      age2 = -3
      age3 = 7
    } else if (age < 50) {
      age1 = -1
      age2 = -5
      age3 = 3
    } else if (age < 60) {
      age1 = 1
      age2 = -5
      age3 = -3
    } else if (age < 70) {
      age1 = 3
      age2 = -3
      age3 = -7
    } else if (age < 80) {
      age1 = 5
      age2 = 1
      age3 = -5
    } else {
      age1 = 7
      age2 = 7
      age3 = 7
    }

    temperature = (temperature > 37.5)
      ? 1
      : 0
    hct = (hct - 39.2609) / 4.9382
    hgb = (hgb - 13.2827) / 1.7563
    lymphocyte = (lymphocyte - 29.1430) / 11.6875
    wbc = (wbc - 6126) /2824
    plt = (plt - 237882.4) / 83295.69


    // Calculate Coef and etc from R
    // coef : age, sob,hgb, lympho, plt,wbc

    const coef0 = -4.565
    const [coef1, coef2, coef3, coef4, coef5, coef6, coef7, coef8] = [
      [
        0.277, 0.04, 0.024
      ],
      1.47,
      0,
      0,
      -0.286,
      -1.013,
      0.186,
      -0.642
    ]
    const [ageMin, sobMin, tempMin, hctMin, hgbMin, lympMin, wbcMin, pltMin] = [
      Math.min(coef1[0] * (-7), coef1[0] * (7)) + Math.min(coef1[1] * (-5), coef1[1] * (7)) + Math.min(coef1[2] * (-7), coef1[2] * (7)),
      Math.min(coef2 * 0, coef2 * 1),
      Math.min(coef3 * 0, coef3 * 1),
      Math.min(coef4*(11.6-39.2609)/4.9382,coef4*(72.9-39.2609)/4.9382),
      Math.min(coef5*(5.2-13.2827)/1.7563,coef5*(20.3-13.2827)/1.7563),
      Math.min(coef6 * (1.2 - 29.1430) / 11.6875, coef6 * (84.1 - 29.1430) / 11.6875),
      Math.min(coef7*(660-6126)/2824,coef7*(55000-6126)/2824),
      Math.min(coef8 * (5300 - 237882.4) / 83295.69, coef8* (734000 - 237882.4) / 83295.69)
    ]
    // Max는 coef가 곱해진 값이다!!
    const [ageMax, sobMax, tempMax, hctMax, hgbMax, lympMax, wbcMax, pltMax] = [
      Math.max(coef1[0] * (-7), coef1[0] * (7)) + Math.max(coef1[1] * (-5), coef1[1] * (7)) + Math.max(coef1[2] * (-7), coef1[2] * (7)),
      Math.max(coef2 * 0, coef2 * 1),
      Math.max(coef3 * 0, coef3 * 1),
      Math.max(coef4*(11.6-39.2609)/4.9382,coef4*(72.9-39.2609)/4.9382),
      Math.max(coef5*(5.2-13.2827)/1.7563,coef5*(20.3-13.2827)/1.7563),
      Math.max(coef6 * (1.2 - 29.1430) / 11.6875, coef6 * (84.1 - 29.1430) / 11.6875),
      Math.max(coef7*(660-6126)/2824,coef7*(55000-6126)/2824),
      Math.max(coef8 * (5300 - 237882.4) / 83295.69, coef8* (734000 - 237882.4) / 83295.69)
    ]
    // Calculating
    const ageVal = (age1 * coef1[0]) + (age2 * coef1[1]) + (age3 * coef1[2])
    const sobVal = sob * coef2
    const tempVal = temperature * coef3
    const hctVal = hct * coef4
    const hgbVal = hgb * coef5
    const lympVal = lymphocyte * coef6
    const wbcVal = wbc * coef7
    const pltVal = plt * coef8

    const agePoint = (ageVal - ageMin)
    const sobPoint = (sobVal - sobMin)
    const tempPoint = (tempVal - tempMin)
    const hctPoint = (hctVal - hctMin)
    const hgbPoint = (hgbVal - hgbMin)
    const lympPoint = (lympVal - lympMin)
    const wbcPoint = (wbcVal - wbcMin)
    const pltPoint = (pltVal - pltMin)

    const totalPoint = agePoint + sobPoint + tempPoint + hctPoint + hgbPoint + lympPoint + wbcPoint + pltPoint
    const maxPoint = ageMax + sobMax + tempMax + hctMax + hgbMax + lympMax + wbcMax + pltMax - (ageMin + sobMin + tempMin + hctMin + hgbMin + lympMin + wbcMin + pltMin)
    const logit = coef0 + ageVal + sobVal + tempVal + hctVal + hgbVal + lympVal + wbcVal + pltVal
    const prob = Math.exp(logit) / (Math.exp(logit) + 1)
    return(prob)
  }

    let c_prob1 = (Math.round(output1(props.data) * 100) / 100).toFixed(2)

    let c_prob2 = (Math.round(output2(props.data) * 100) / 100).toFixed(2)
    let c_prob3 = (Math.round(output3(props.data) * 100) / 100).toFixed(2)

    let prob1 = Math.max(1-c_prob1,0)
    let prob2 = Math.max(c_prob1-c_prob2,0)
    let prob3 = Math.max(c_prob2-c_prob3,0)
    let prob4 = Math.max(c_prob3,0)
    const total = prob1+prob2+prob3+prob4
    prob1=Math.round((prob1/total)*100)
    prob2=Math.round((prob2/total)*100)
    prob3=Math.round((prob3/total)*100)
    prob4=Math.round((prob4/total)*100)


    const probs= [prob1,prob2,prob3,prob4]

    const maxColor = 'rgba(255,99,132,0.4)'
    let backgroundColor = ['rgba(96,125,139,0.2)',
    'rgba(96,125,139,0.3)',
    'rgba(96,125,139,0.3)',
    'rgba(96,125,139,0.3)']
    let maxIdx=0
    for(let i = 1; i < 4; i++){
      if(probs[maxIdx]<probs[i]){
        maxIdx=i
      }
    }
    backgroundColor[maxIdx]=maxColor
    data.datasets[0].data = probs
    data.datasets[0].backgroundColor = backgroundColor
    let options = {
      title: {
        display: true,
        text: 'Estimated Probability',
        fontSize: 20
      },
      legend:{
        display: false
      },
        scales: {
            yAxes: [{
                ticks: {
                    min: 0, // 스케일에 대한 최솟갓 설정, 0 부터 시작
                    max: 100,
                    stepSize: 10, // 스케일에 대한 사용자 고정 정의 값
                    fontSize: 14

                },
                scaleLabel: {
                  display: true,
                  labelString: '%',
                  fontSize: 15
                }

            }],
          xAxes: [{
              ticks: {
                  fontSize: 17,
                  fontStyle:'bold',
              }

          }]
        },
        maintainAspectRatio: false // false로 설정 시 사용자 정의 크기에 따라 그래프 크기가 결정됨.
    }

    return (<Box border="3px solid gray">
    <Bar
      data={data}
      width={100}
      height={500}
      options={options}
      />
    </Box>)
  }

  export default Output
